import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "iframe-container"
};
var _hoisted_2 = {
  key: 0,
  class: "iframe-container__loading"
};
var _hoisted_3 = ["src"];
import { storeToRefs, ref, nextTick, onMounted, onBeforeUnmount, watchEffect } from 'vue';
import { getStore } from '@/util/store';
export default {
  __name: 'IframeContainer',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  emits: ['onload', 'getFile'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _ref2 = getStore({
        name: 'accessInfo'
      }) || {},
      access_token = _ref2.access_token;
    var props = __props;
    var emits = __emit;
    // 定义状态
    var isLoaded = ref(false);
    var loading = ref(true);
    var iframeRef = ref(null);
    var showLoading = function showLoading() {
      loading.value = true;
    };
    var hideLoading = function hideLoading() {
      loading.value = false;
    };

    // 重新加载 iframe 的方法
    var reloadIframe = function reloadIframe() {
      nextTick(function () {
        showLoading();
        isLoaded.value = false;
        if (iframeRef.value) {
          if (iframeRef.value.attachEvent) {
            iframeRef.value.attachEvent('onload', function () {
              isLoaded.value = true;
              hideLoading();
              emits('onload');
            });
          } else {
            iframeRef.value.onload = function () {
              return hideLoading();
            };
            emits('onload');
          }
        }
      });
    };
    // 监听窗口大小变化，重新加载 iframe
    var messageHandler = null;
    var handleJumpToApp = function handleJumpToApp(obj) {
      console.log(obj);
    };
    var handleCreate = function handleCreate() {
      var url = "".concat(window.location.origin, "/objectivesMandate?objectivesMandate=/sub-objectives-mandate-svc/targetManagement?handle=create&token=").concat(access_token);
      if (!window.JSAndroid || !window.JSAndroid.startNewWeb) {
        window.open(url);
      } else {
        window.JSAndroid.startNewWeb(JSON.stringify({
          url: url,
          title: '目标',
          showTitle: false
        }));
      }
    };
    onMounted(function () {
      // 修复：使用正确的事件名称 'load'
      window.addEventListener('load', reloadIframe);
      // 创建消息处理函数并保存引用
      messageHandler = function messageHandler(msg) {
        console.log(msg.data);
        var _msg$data = msg.data,
          type = _msg$data.type,
          data = _msg$data.data;
        if (type === 'jump') {
          var path = data.path;
          console.log(path);
          var url = "".concat(window.location.origin, "/objectivesMandate?objectivesMandate=/sub-objectives-mandate-svc").concat(path, "?token=").concat(access_token);
          if (!window.JSAndroid || !window.JSAndroid.startNewWeb) {
            window.open(url);
          } else {
            window.JSAndroid.startNewWeb(JSON.stringify({
              url: url,
              title: '目标',
              showTitle: false
            }));
          }
        }
        /*try {
          const { data } = msg
          // 确保数据存在且是字符串
          if (typeof data === 'string') {
            const ParseData = JSON.parse(data)
            console.log('getFile', ParseData)
            emits('getFile', ParseData)
          }
        } catch (error) {
          console.error('Message parsing error:', error)
        }*/
      };
      window.addEventListener('message', messageHandler);
    });
    onBeforeUnmount(function () {
      // 正确移除所有监听器
      window.removeEventListener('load', reloadIframe);
      if (messageHandler) {
        window.removeEventListener('message', messageHandler);
      }
    });

    // 监听 `isLoaded` 的变化
    watchEffect(function () {
      if (!isLoaded.value) {
        reloadIframe();
      }
    });
    return function (_ctx, _cache) {
      var _component_t_loading = _resolveComponent("t-loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_t_loading)])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("iframe", {
        ref_key: "iframeRef",
        ref: iframeRef,
        class: "iframe-container__iframe",
        src: props.src,
        frameborder: "0",
        scrolling: "no",
        allow: "autoplay",
        allowfullscreenameborder: "0",
        allowfullscreen: ""
      }, null, 8, _hoisted_3), [[_vShow, !loading.value && !isLoaded.value]]), _withDirectives(_createElementVNode("div", {
        class: "add-icon",
        onClick: handleCreate
      }, " + ", 512), [[_vShow, !loading.value && !isLoaded.value]])]);
    };
  }
};